module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


//////////////////
// WEBPACK FOOTER
// ./~/htmlparser2/lib/entities/xml.json
// module id = 319
// module chunks = 0